

















































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import FormBoxComponent from "@/components/common/form/FormBoxComponent.vue";
import FormRowComponent from "@/components/common/form/FormRowComponent.vue";
import FormTitleComponent from "@/components/pages/master_managements/FormTitleComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import SaveDialogComponent from "@/components/common/parts/SaveDialogComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import ExchangeDialogComponent from "@/components/pages/store_infos/ExchangeDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import { getStoresApi } from "../typescript/api_client/emesh_api/stores/stores_api";
import { getStoresPinApi } from "../typescript/api_client/emesh_api/stores/stores_pin_api";
import { getStoreSensorsApi } from "@/typescript/api_client/emesh_api/stores/store_sensors_api";
import { getStoreUsersApi } from "@/typescript/api_client/emesh_api/users/store_users_api";
import { storeMenus } from "@/config/store_menus";
import { getRoutePath } from "@/router/routes";
import { postEquipmentsRemovalApi } from "@/typescript/api_client/emesh_api/equipments/equipments_removal_api";
import { registerStoreApi } from "@/typescript/api_client/emesh_api/stores/stores_register_api";
import {
  GetStoreSensorsResponseSensor,
  GetStoreSensorsResponse,
  GetStoresResponse,
  GetStoresPinResponse,
  Store
} from "@/typescript/api_client/emesh_api/stores/types";
import {
  GetStoreUsersResponse,
  StoreUser
} from "@/typescript/api_client/emesh_api/users/types";
import { Moment } from "@/typescript/lib/common/moment";

export {
  GetStoreUsersResponse,
  GetStoreSensorsResponseSensor,
  GetStoreSensorsResponse,
  GetStoresResponse,
  GetStoresPinResponse,
  Store,
  StoreUser
};

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    FormBoxComponent,
    FormRowComponent,
    FormTitleComponent,
    ButtonComponent,
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    EllipsisComponent,
    SaveDialogComponent,
    ConfirmDialogComponent,
    ExchangeDialogComponent,
    FooterComponent
  }
})
export default class MasterManagementsPage extends Vue {
  store: Store | {} = {};
  sensors: GetStoreSensorsResponseSensor[] = [];
  users: StoreUser[] = [];
  //isRemoved: boolean = false;
  isInstalled: boolean = true;
  isExistDiagram: boolean = false;
  pinCode: string = "";
  effectiveTime: string = ""; // 2021.08.24 追加
  queries: { [s: string]: any } | null = null;
  workingState: number | null = null;
  gatewayInfo: string | null = null;

  isDisplayDialog: boolean = false;
  isExchangeDialog: boolean = false;

  isRemovalDialog: boolean = false;
  confirmDialogMsg: string = "";

  dialogMsg: string = "";
  exchangeGatewayInfo: string = "";

  // 有効フラグ
  get isValid() {
    return 1;
  }

  // // 稼働情報
  // get workingState(): { [s: string]: number } {
  //   return {
  //     run: 1, // 稼動中
  //     removed: 2 // 撤去済み
  //   };
  // }

  get workingStateName() {
    if (this.workingState === null) return "稼働情報なし";
    else if (this.workingState === 0) return "初回通信待ち";
    else if (this.workingState === 1) return "稼働中";
    else if (this.workingState === 2) return "撤去";
    return "";
  }

  get isExchange() {
    if (this.workingState === 1 || this.workingState === 2) return true;
    return false;
  }

  get isWorking() {
    if (this.workingState === 1) return true;
    return false;
  }

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "MasterManagementsPage")
        ?.id
    });
    this.setStore();
    this.setStoreSensor();
    this.serUsers();
  }

  // 警告メール通知がONならtrueを返す
  isAlertOn(alertFilter): boolean {
    // 2:警報メールを飛ばさない
    if (alertFilter === 2) return false;
    // 0:発生・復旧ともに警報メールを飛ばす、1:警報発生時のみメールを飛ばす
    return true;
  }

  // PINコード再発行
  issuePinCode() {
    getStoresPinApi(this.$route.params.store_id).then(
      (resp: GetStoresPinResponse) => {
        this.pinCode = resp.pin_code;
        this.effectiveTime = resp.effective_time;
      }
    );
  }

  // 撤去
  openRemovalDialog() {
    this.isRemovalDialog = true;
  }

  closeRemovalDialog() {
    this.isRemovalDialog = false;
  }

  removal() {
    this.closeRemovalDialog();
    postEquipmentsRemovalApi({
      equipment_id: this.gatewayInfo !== null ? this.gatewayInfo : ""
    })
      .then(() => {
        // 成功時は不要
        // this.openDisplayDialog("撤去に成功しました");
        this.setStore();
      })
      .catch(() => {
        this.openDisplayDialog("撤去に失敗しました");
      });
  }

  // 交換
  openExchangeDialog() {
    this.isExchangeDialog = true;
  }

  closeExchangeDialog() {
    this.isExchangeDialog = false;
  }

  setExchangeGateway(value: any) {
    this.exchangeGatewayInfo = value;
  }

  registExchangeGateway() {
    if (this.exchangeGatewayInfo.trim().length == 0) {
      return;
    }
    this.closeExchangeDialog();
    const resp = this.store as GetStoresResponse;
    const storeData = {
      store_id: resp.store_id,
      store_no: resp.store_no,
      store_name: resp.store_name,
      prefecture_id: resp.prefecture_id,
      address: resp.address,
      tel_no: resp.tel_no,
      opening_date: this.formatDate(resp.opening_date),
      closing_date: resp.closing_date
        ? this.formatDate(resp.closing_date)
        : null,
      storegroup_id: resp.storegroup_id,
      usergroup: resp.usergroup.map(x => x.usergroup_id),
      gateway_info: this.exchangeGatewayInfo
    };
    registerStoreApi(storeData)
      .then(() => {
        // 成功時は不要
        // this.openDisplayDialog("交換に成功しました");
        this.setStore();
      })
      .catch(() => {
        this.openDisplayDialog("交換に失敗しました");
      });
  }

  // ダイアログ
  openDisplayDialog(message: string) {
    this.dialogMsg = message;
    this.isDisplayDialog = true;
  }

  closeDisplayDialog() {
    this.isDisplayDialog = false;
  }

  setStoreSensor() {
    getStoreSensorsApi(this.$route.params.store_id).then(
      (resp: GetStoreSensorsResponse) => {
        this.sensors = resp.sensors;
        // 全てポジション0だったら未設置として扱う
        this.isInstalled = resp.sensors.some(
          sensor => sensor.position_x !== 0 || sensor.position_y !== 0
        );
      }
    );
  }

  setStore() {
    getStoresApi(this.$route.params.store_id).then(
      (resp: GetStoresResponse) => {
        this.store = resp;
        // diagram_idがnullなら店舗図未設定
        const isExistDiagram = resp.diagram_id !== null;
        this.isExistDiagram = isExistDiagram;
        //this.isRemoved = resp.working_state === 2;
        this.workingState = resp.working_state;
        this.gatewayInfo = resp.gateway_info;
        if (isExistDiagram) {
          this.queries = { diagram_id: resp.diagram_id };
        }
        // 2021.08.25 PINコード取得追加
        this.pinCode = resp.pin_code;
        this.effectiveTime = resp.effective_time;
      }
    );
  }

  serUsers() {
    getStoreUsersApi(this.$route.params.store_id).then(
      (resp: GetStoreUsersResponse) => {
        this.users = resp;
      }
    );
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  convertDateFormat(date: string) {
    return new Moment(
      "YYYY/MM/DD",
      date,
      "YYYY/MM/DD HH:mm:ss"
    ).getFormatDate();
  }

  formatDate(date): string {
    if (date) {
      const newDate = new Moment("YYYYMMDD", date);
      return newDate.getFormatDate();
    }
    return "";
  }

  // 2021.08.25 有効期限変換用に追加
  convertDateTimeFormat(date: string) {
    return new Moment(
      "YYYY/MM/DD HH:mm:ss",
      date,
      "YYYYMMDDHHmmss"
    ).getFormatDate();
  }
}
